import { debugTracking } from '$lib/debug';

import increaseSequentialId from './increaseSequentialId';
import { pageTrackBlacklist } from './integrations';
import trackingOptions from './options';
import exec from './v3.exec';
import { getGlobals } from '../globals';

const isProduction = process.env.NODE_ENV === 'production';

export const track = (name: string, trackingObj: any, optionsName: string) => {
    const options = trackingOptions[optionsName];

    debugTracking('-> V3 track:', !!window.analytics, name, trackingObj, options);

    const globals = getGlobals();

    if (isProduction) {
        if (options.tracking.perspective) {
            const adjustedTrackingObj = {
                ...globals,
                ...trackingObj,
            };

            if (options.sequential) {
                adjustedTrackingObj.sequentialId = increaseSequentialId();
            }

            exec.track(name, adjustedTrackingObj);
        }

        if (options.tracking.integrations && window.analytics) {
            debugTracking(
                '-> V3 track: window.analytics.track',
                name,
                trackingObj,
                options.passThrough,
            );

            window.analytics.track(
                name,
                {
                    ...trackingObj,
                    anonymousId: globals.anonymousId,
                },
                options.passThrough,
            );
        }
    }
};

export const page = (pageName: string, trackingObj: any) => {
    debugTracking('-> V3 page:', !!window.analytics, pageName, trackingObj);

    if (isProduction) {
        exec.page(pageName, trackingObj);

        if (window.analytics) {
            window.analytics.page(null, pageName, trackingObj, pageTrackBlacklist);
        }
    }
};

export const identify = (userInformation?: { [key: string]: any }) => {
    const globals = getGlobals();
    const id = globals.anonymousId;

    debugTracking('-> V3 identify:', !!window.analytics, userInformation);

    if (window.analytics && isProduction) {
        window.analytics.identify(id, userInformation);
    }
};

export default {
    track,
    page,
    identify,
};
